import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { remitPageMeta, remitSchema } from 'components/common/schema'
import Template from 'components/cases/remit'

const Remit: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...remitPageMeta} />
      <JsonLd data={remitSchema} />
      <Template />
    </>
  )
}

export default Remit
